export default "__VITE_ASSET__DYD_7iv2__"